import {
  hasIntersectionObserver,
  hasResizeObserver,
} from '~/utils/browserSupport'

const settle = promise =>
  promise.catch(error => {
    console.warn('observer polyfills load failed', error)
  })

const exposeIsIntersecting = () => {
  const { prototype } = window.IntersectionObserverEntry
  if ('isIntersecting' in prototype) return
  Object.defineProperty(prototype, 'isIntersecting', {
    get() {
      return this.intersectionRatio > 0
    },
  })
}

export default async () => {
  const pending = []

  if (!hasIntersectionObserver()) {
    pending.push(
      settle(import('intersection-observer').then(exposeIsIntersecting))
    )
  }

  if (!hasResizeObserver()) {
    pending.push(
      settle(
        import('resize-observer-polyfill').then(
          ({ default: ResizeObserver }) => {
            window.ResizeObserver = ResizeObserver
          }
        )
      )
    )
  }

  await Promise.all(pending)
}
